import { Col, Flex, Form, List, Row, Select, Switch, Typography } from "antd";
import React, { useEffect } from "react";
import RequiredLabel from "../../../../common/required-label/RequiredLabel";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { updateOrgPermissionAction } from "../../../../../redux/services/user-permissions/userPermissionServices";
import useLocalStorage from "../../../../../hooks/useLocalStorage";
import { appConfig } from "../../../../../constants/config/appConfig";

const UserPermissions = () => {
  /* i18n dependencies */
  const { t } = useTranslation();
  /* i18n dependencies */

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  /* loading dependencies */

  /* form dependencies */
  const [form] = Form.useForm();
  const role = Form.useWatch("role", { form, preserve: true });
  /* form dependencies */

  /* select list dependencies */
  const [selectedRole, setSelectedRole] = useState(null);
  const [selectedRolePermissions, setSelectedRolePermissions] = useState([]);
  /* select list dependencies */

  /* loading dependencies */
  const [selectListLoader, setSelectListLoader] = useState(false);
  /* loading dependencies */

  /* local storage dependencies */
  const { userSession, setUserSession } = useLocalStorage(
    appConfig.SESSION_USER_INFO
  );
  /* local storage dependencies */

  const dispatch = useDispatch();

  const userRoleAndPermissions = useSelector(
    (state) => state.auth?.loginDetails?.organization_id?.permissions
  );


  const constructRoleLabel = (role) => {
    switch (role) {
      case "staff":
        return "Staff";
      case "medical_staff":
        return "Medical Staff";
      case "doctor":
        return "Doctor";
      default:
        return role;
    }
  };
  const constructPermissions = userRoleAndPermissions?.map((item) => {
    return {
      value: item.role,
      _id: item._id,
      label: constructRoleLabel(item.role),
      permissions: item?.permissions.map((permission) => {
        return {
          id: permission._id,
          module: permission.name,
          permission_granted: permission.is_active,
          role: item.role,
        };
      }),
    };
  });

  const onRoleChanged = (id, value) => {
    if (value && value !== undefined && value !== null) {
      setSelectedRole(value);
      setSelectedRolePermissions(value?.permissions);
    }
  };

  const onPermissionChanged = (value, item) => {
    let dateToBeSent = {
      permission_id: item.id,
      is_active: value,
      role: item.role,
    };
    dispatch(
      updateOrgPermissionAction(dateToBeSent, setLoading, setUserSession)
    );
  };

  return (
    <>
      <Form
        form={form}
        layout="vertical"
        autoComplete="off"
        requiredMark={false}
      >
        <Row gutter={[16, 16]}>
          <Col span={8}>
            <Form.Item
              name="role"
              label={
                <RequiredLabel
                  text={t("Modules.UserPermissions.role")}
                  required={true}
                />
              }
              rules={[
                {
                  required: true,
                  message: t("Modules.UserPermissions.pleaseSelectRole"),
                },
              ]}
            >
              <Select
                loading={selectListLoader}
                options={constructPermissions}
                onChange={onRoleChanged}
                placeholder={t("Modules.UserPermissions.selectRole")}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Typography.Title level={2}>
              {t("userPermission.permission")}
            </Typography.Title>
            <List
              dataSource={
                constructPermissions &&
                constructPermissions?.find(
                  (item) => item.value === selectedRole?.value
                )?.permissions
              }
              header={
                <>
                  <Flex justify="space-between" align="center">
                    <Typography.Title
                      style={{ margin: 0 }}
                      type="secondary"
                      level={4}
                    >
                      {t("userPermission.tab")}
                    </Typography.Title>
                    <Typography.Title
                      style={{ margin: 0 }}
                      type="secondary"
                      level={4}
                    >
                      {t("userPermission.action")}
                    </Typography.Title>
                  </Flex>
                </>
              }
              renderItem={(item) => (
                <List.Item key={item.module}>
                  <List.Item.Meta
                    style={{ alignItems: "center" }}
                    title={
                      <Flex justify="space-between" align="center">
                        <Typography.Text
                          type="secondary"
                          style={{ margin: 0 }}
                          level={4}
                        >
                          {item.module}
                        </Typography.Text>
                        <Form.Item name="status" style={{ margin: 0 }}>
                          <Switch
                            checkedChildren={<CheckOutlined />}
                            unCheckedChildren={<CloseOutlined />}
                            defaultChecked={item.permission_granted}
                            checked={item.permission_granted}
                            onClick={(e) => onPermissionChanged(e, item)}
                          />
                        </Form.Item>
                      </Flex>
                    }
                  />
                </List.Item>
              )}
            />
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default UserPermissions;
